import { ShapefileBundleWizardProps, WizardStep } from "../Wizard";
import { SimpleTreeView, TreeItem } from "@mui/x-tree-view";
import { useTranslation } from "react-i18next";
import FarmIcon from "portal/images/icons/farm.svg?react";
import FieldIcon from "portal/images/icons/field.svg?react";
import React from "react";

export const PreviewAndFinish: WizardStep<ShapefileBundleWizardProps> = {
  stepNameI18NKey: "views.farms.importFarms.step5PreviewAndFinish.stepName",
  Render: ({ farmsForImport }) => {
    const { t } = useTranslation();

    return (
      <>
        <div>
          {t("views.farms.importFarms.step5PreviewAndFinish.selectedFields")}
        </div>
        <SimpleTreeView className="border-solid border-gray-300 border-2 flex-auto overflow-y-auto">
          {farmsForImport.map(
            (farm) =>
              farm.id && (
                <TreeItem
                  key={farm.id.id}
                  itemId={farm.id.id}
                  label={
                    <span>
                      <FarmIcon width={24} height={24} /> {farm.name}
                    </span>
                  }
                >
                  {farm.zones.map(
                    (zone) =>
                      zone.id && (
                        <TreeItem
                          key={zone.id.id}
                          itemId={zone.id.id}
                          label={
                            <span>
                              <FieldIcon width={24} height={24} /> {zone.name}
                            </span>
                          }
                        />
                      )
                  )}
                </TreeItem>
              )
          )}
        </SimpleTreeView>
      </>
    );
  },
  mapSelectionEnabled: false,
  canAdvancePastStep: () => true,
};
